import React from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { Wrapper, WrapperBooleans } from './styled';
import NonBooleanField from './components/NonBooleanField';
import BooleanField from './components/BooleanField';
import { useSelector } from 'react-redux';
import { selectPathname } from 'store/Router/selectors';

const Content = ({ defaultParams, currentTool, onChangeField, targetError, disabled }) => {
  const userAgentParams = get(currentTool, 'parameters_metadata', []);
  const booleanParams = Object.keys(userAgentParams).filter((param) => userAgentParams[param].base === 'boolean');
  const nonBooleanParams = Object.keys(userAgentParams).filter((param) => userAgentParams[param].base !== 'boolean');
  const pathname = useSelector(selectPathname);
  const isScheduler = pathname === '/automation/schedule';
  if (isEmpty(currentTool) || isEmpty(userAgentParams)) return null;
  return (
    <Wrapper>
      { nonBooleanParams.map((param) => <NonBooleanField key={ param } defaultValue={ get(defaultParams, param, '') } param={ param } parameters={ userAgentParams } onChangeField={ onChangeField } targetError={ targetError } disabled={ disabled } />) }
      { isScheduler
        ? <WrapperBooleans>{ booleanParams.map((param) => <BooleanField key={ param } defaultValue={ get(defaultParams, param, false) } param={ param } parameters={ userAgentParams } onChangeField={ onChangeField } isScheduler={ isScheduler } disabled={ disabled } />)}</WrapperBooleans>
        : <>{ booleanParams.map((param) => <BooleanField key={ param } defaultValue={ get(defaultParams, param, false) } param={ param } parameters={ userAgentParams } onChangeField={ onChangeField } disabled={ disabled } />)}</>
      }
    </Wrapper>
  );
};

export default Content;
